/**
 * ImageView — an image (or a moment's frame) fitted to the viewer; the file
 * card when the browser can't decode it (HEIC outside Safari).
 */
import { useState, type ReactNode } from 'react';

const IMAGE_CLASS = 'max-h-full max-w-full rounded-md object-contain';

export interface ImageViewProps {
  src: string;
  name: string;
  fallback: ReactNode;
}

export function ImageView({ src, name, fallback }: ImageViewProps) {
  const [undecodable, setUndecodable] = useState(false);

  function handleError(): void {
    setUndecodable(true);
  }

  if (undecodable) return fallback;
  return <img src={src} alt={name} className={IMAGE_CLASS} onError={handleError} />;
}
